<!--
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-09-25 16:26:30
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-11-24 11:16:32
 * @FilePath: \web\src\components\page\xiangMu.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <globalTitle />
    <div>
      <el-card class="mart10">
        <div>
          <el-date-picker
            v-model="queryParams.year"
            type="year"
            value-format="yyyy"
            @change="yearChange"
            placeholder="选择年">
          </el-date-picker>
        </div>
        <h4>神农公益基金会{{ queryParams.year }}年度立项列表</h4>
        <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
          <!-- :header-cell-style="{textAlign: 'center'}"设置头部居中： -->
          <!-- :cell-style="{ textAlign: 'center' }"设置整个表格内容水平居中： -->
          <el-table-column prop="serial" label="序号" width=""> </el-table-column>
          <el-table-column prop="code" label="立项编号" width=""> </el-table-column>
          <el-table-column prop="name" label="项目名称"> </el-table-column>
          <el-table-column prop="form" label="项目形式"> </el-table-column>
          <el-table-column prop="charger" label="项目负责人"> </el-table-column>
          <el-table-column prop="endTime" label="结项时间"> </el-table-column>
          <el-table-column prop="mark" label="备注"> </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import globalTitle from '../globalTitle.vue'
import { getProjectList } from '@/api/project.js'

export default {
  components: { globalTitle },
  name: 'xiangMu',
  data() {
    return {
      queryParams: {
        year: '2023',
        month: '',
        name: '',
        pageSize: 10,
        total: 10,
        currentPage: 1
      },
      tableData: []
    }
  },
  created() {},
  mounted() {
    let timestamp = Date.parse(new Date());
    let date = new Date(timestamp);
    //获取年份
    let thisYear = date.getFullYear() + '';
    console.log('this year', thisYear, typeof(thisYear));
    this.queryParams.year = thisYear ;
    this.search();
  },
  methods: {
    yearChange(val) {
      this.queryParams.year = val;
      this.search();
    },
    search () {
      getProjectList(this.queryParams).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.queryParams.total = res.data.total;
          this.queryParams.currentPage = res.data.current;
          this.queryParams.pageSize = res.data.size;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
h4 {
  text-align: center;
  margin-top: 0;
}
.mart10 {
  margin-top: 10px;
}
</style>
